export enum UserAuthority {
  ADMIN = 'admin',
  VENDOR = 'vendor',
  CHANNEL = 'channel',
  REVIEW = 'review',
  PROPERTY = 'property',
  GUEST = 'guest',
}
